import React from "react";
import { useLang } from "@/i18n";
import { useNavigate } from "react-router-dom";
import { FileWarning, FileText } from "lucide-react";
import DashboardSectionCard from "@/components/dashboard/DashboardSectionCard";
import DashboardCardAction from "@/components/dashboard/DashboardCardAction";
import { cn } from "@/lib/utils";
import { docSeverity } from "@/lib/docStatus";

export { docSeverity };

export default function ExpiringDocumentsCard({ docs = [] }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const list = docs.slice(0, 5);

  return (
    <DashboardSectionCard
      title={t("dash.card.expiringDocs")}
      icon={FileWarning}
      iconClass={docs.length > 0 ? "text-warning" : "text-muted-foreground"}
      count={docs.length}
      testid="card-expiring-docs"
      footer={
        <DashboardCardAction to="/documents" testid="expiring-docs-see-all">
          {t("dash.card.seeAllDocs")}
        </DashboardCardAction>
      }
    >
      {list.length === 0 ? (
        <div className="flex-1 flex items-center justify-center py-10 text-xs text-muted-foreground" data-testid="expiring-docs-empty">
          {t("dash.card.noExpiringDocs")}
        </div>
      ) : (
        <ol className="flex-1 min-h-0 overflow-y-auto overscroll-contain space-y-1" data-testid="expiring-docs-list">
          {list.map((d) => {
            const sev = docSeverity(d.days_left);
            return (
              <li key={d.id}>
                <button
                  onClick={() => d.player?.id && navigate(`/players/${d.player.id}`)}
                  className="w-full flex items-center gap-2.5 rounded-lg px-2 py-2 hover:bg-secondary/60 transition-colors text-left"
                  data-testid={`expiring-doc-${d.id}`}
                >
                  <div className="shrink-0 h-8 w-8 rounded-lg bg-secondary/80 border border-border flex items-center justify-center">
                    <FileText className="h-3.5 w-3.5 text-muted-foreground" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate">{d.label || d.filename}</div>
                    <div className="text-[11px] text-muted-foreground truncate">{d.player?.name || "—"}</div>
                  </div>
                  <span className={cn("shrink-0 inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold tabular-nums", sev.cls)}>
                    {sev.label}
                  </span>
                </button>
              </li>
            );
          })}
        </ol>
      )}
    </DashboardSectionCard>
  );
}
